import React, { memo } from 'react';
import KeyHandler from '../KeyHandler';
import setPath from '@/lib/setPath';
import Page from '@/components/page/Page.jsx';
import matchQuery from '@/lib/matchQuery.js';

const PanelTabs = memo(({ tabs, onClick, bindHotkeys = false, tabKey, replace = true, style = {}, className = '' }) => {
  if (!tabs || !tabs.length) {
    return null;
  }

  const mappedTabs = tabs.map((tab) => ({
    label: tab?.label,
    value: tab?.value || tab?.route,
    active: matchQuery(tab?.query) || window.location.pathname.includes(tab?.route),
    icon: tab?.icon,
    iconProps: tab?.iconProps,
    title: tab?.title
  }));

  const hasFocusedInput = () => {
    const activeElement = document.activeElement;
    const isInputElement = activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.isContentEditable;

    if (!isInputElement) return false;

    const content = activeElement.isContentEditable ? activeElement.textContent : activeElement.value;

    return content.length >= 1;
  };

  const handleTabChange = (direction) => () => {
    if (hasFocusedInput()) {
      return;
    }
    const currentIndex = mappedTabs.findIndex((tab) => tab.active);
    const nextIndex = direction === 'left' ? currentIndex - 1 : currentIndex + 1;
    if (nextIndex >= 0 && nextIndex < tabs.length) {
      setPath(tabs[nextIndex].route, { replace });
    }
  };

  const windowKeyMap = {
    'Shift+Meta+ArrowLeft': handleTabChange('left'),
    'Shift+Control+ArrowLeft': handleTabChange('left'),
    'Shift+Meta+ArrowRight': handleTabChange('right'),
    'Shift+Control+ArrowRight': handleTabChange('right')
  };

  return (
    <div className={`comp-panel-tabs ${className}`} style={style}>
      <Page.Tabs items={mappedTabs} tabKey={tabKey || 'tab'} onClick={onClick} />
      {bindHotkeys && <KeyHandler keyMap={windowKeyMap} stopPropagation={true} global={true} />}
    </div>
  );
});

PanelTabs.displayName = 'PanelTabs';

export default PanelTabs;
